import { AxiosInstance } from 'axios';
import getActivityServices from '../services/activity';
import getNormalServices from '../services/normal';
import getPlayerServices from '../services/player';
import getUserServices from '../services/user';
import getCardServices from '../services/card';
import getRoleServices from '../services/role';
import getLoginServices from '../services/login';
import getDownloadServices from '../services/download';
import getSpaceServices from '../services/space';

type CommonServices = {
  activity: ReturnType<typeof getActivityServices>;
  normal: ReturnType<typeof getNormalServices>;
  player: ReturnType<typeof getPlayerServices>;
  user: ReturnType<typeof getUserServices>;
  card: ReturnType<typeof getCardServices>;
  role: ReturnType<typeof getRoleServices>;
  login: ReturnType<typeof getLoginServices> | null;
  download: ReturnType<typeof getDownloadServices>;
  space: ReturnType<typeof getSpaceServices>;
};

let commonServices: {
  current: CommonServices | null;
} = { current: null };

// eslint-disable-next-line react-func/max-lines-per-function
export function createService({
  GateWayInstance,
  RbacGateWayInstance,
  LoginGateWayInstance,
}: {
  GateWayInstance: AxiosInstance;
  RbacGateWayInstance?: AxiosInstance;
  LoginGateWayInstance?: AxiosInstance;
}) {
  if (commonServices.current) return commonServices.current;
  commonServices.current = {
    activity: getActivityServices({
      GateWayInstance,
    }),
    normal: getNormalServices({
      GateWayInstance,
    }),
    player: getPlayerServices({
      GateWayInstance,
    }),
    user: getUserServices({
      GateWayInstance,
      LoginGateWayInstance: LoginGateWayInstance!,
    }),
    card: getCardServices({
      GateWayInstance,
    }),
    role: getRoleServices({
      GateWayInstance,
    }),
    login: getLoginServices({
      RbacGateWayInstance: RbacGateWayInstance!,
      LoginGateWayInstance: LoginGateWayInstance!,
    }),
    download: getDownloadServices({
      GateWayInstance,
    }),
    space: getSpaceServices({
      GateWayInstance,
    }),
  };
  return commonServices.current;
}

export default commonServices;
